export default "__VITE_ASSET__C4vPAJqN__"